var pdfjsLib = window["pdfjs-dist/build/pdf"];
export const getHightlightCoords = () => {
  let pageArea = document.getElementById("page-area");
  if (!pageArea) return;
  let iframe = pageArea.getElementsByTagName("iframe")[0];
  if (!iframe) return;
  let iWin = iframe.contentWindow || iframe.contentDocument?.defaultView;
  var pageIndex = iWin.PDFViewerApplication.pdfViewer.currentPageNumber - 1;
  var page = iWin.PDFViewerApplication.pdfViewer.getPageView(pageIndex);
  var pageRect = page.canvas.getClientRects()[0];
  var selectionRects = iWin.getSelection().getRangeAt(0).getClientRects();
  var viewport = page.viewport;
  let tempRect = [];
  for (let i = 0; i < selectionRects.length; i++) {
    if (i === 0) {
      tempRect.push({
        bottom: selectionRects[i].bottom,
        top: selectionRects[i].top,
        left: selectionRects[i].left,
        right: selectionRects[i].right,
      });
    } else if (
      Math.abs(
        tempRect[tempRect.length - 1].bottom - selectionRects[i].bottom
      ) < 5
    ) {
      if (tempRect[tempRect.length - 1].left > selectionRects[i].left) {
        tempRect[tempRect.length - 1].left = selectionRects[i].left;
      }
      if (tempRect[tempRect.length - 1].right < selectionRects[i].right) {
        tempRect[tempRect.length - 1].right = selectionRects[i].right;
      }
    } else {
      tempRect.push({
        bottom: selectionRects[i].bottom,
        top: selectionRects[i].top,
        left: selectionRects[i].left,
        right: selectionRects[i].right,
      });
    }
  }
  var selected = tempRect.map(function (r) {
    return viewport
      .convertToPdfPoint(r.left - pageRect.x, r.top - pageRect.y)
      .concat(
        viewport.convertToPdfPoint(r.right - pageRect.x, r.bottom - pageRect.y)
      );
  });
  return { page: pageIndex, coords: selected };
};
export const getPDFCover = (file) => {
  return new Promise((resolve, reject) => {
    pdfjsLib
      .getDocument({ data: file })
      .promise.then((pdfDoc) => {
        pdfDoc.getPage(1).then((page) => {
          var scale = 1.5;
          var viewport = page.getViewport({
            scale: scale,
          });
          var canvasArr = document.getElementsByClassName("canvas");

          var canvas = document.createElement("canvas");

          canvas.id = "canvas" + canvasArr !== undefined ? canvasArr.length : 0;

          canvas.classList.add("canvas");

          var canvasDiv = document.getElementById("the-canvas");

          canvasDiv.appendChild(canvas);

          var context = canvas.getContext("2d");
          canvas.height =
            viewport.height || viewport.viewBox[3]; /* viewport.height is NaN */
          canvas.width =
            viewport.width ||
            viewport.viewBox[2]; /* viewport.width is also NaN */
          var task = page.render({
            canvasContext: context,
            viewport: viewport,
          });
          task.promise.then(async () => {
            let cover = canvas.toDataURL("image/jpeg");

            canvas.remove();

            resolve(cover);
          });
        });
      })
      .catch((err) => {
        resolve("");
      });
  });
};

export const getCustHightlightCoords = () => {
  let pageArea = document.getElementById("page-area");

  if (!pageArea) return;
  let iframe = pageArea.getElementsByTagName("iframe")[0];

  if (!iframe) return;
  let iWin = iframe.contentWindow || iframe.contentDocument?.defaultView;

  var pageIndex = iWin.PDFViewerApplication.pdfViewer.currentPageNumber - 1;
  var page = iWin.PDFViewerApplication.pdfViewer.getPageView(pageIndex);
  var pageRect = page.canvas.getClientRects()[0];
  var selectionRects = iWin.getSelection().getRangeAt(0).getClientRects();
  var viewport = page.viewport;

  console.log("getCustHightlightCoords1", pageArea);
  console.log("getCustHightlightCoords2", iframe);
  console.log("getCustHightlightCoords3", iWin);
  console.log("getCustHightlightCoords4", iframe.contentWindow);
  console.log("getCustHightlightCoords5", iframe.contentDocument?.defaultView);
  console.log("getCustHightlightCoords6", pageRect);
  console.log("getCustHightlightCoords7", selectionRects);
  console.log("getCustHightlightCoords8", viewport);

  let tempRect = [];
  for (let i = 0; i < selectionRects.length; i++) {
    if (i === 0) {
      tempRect.push({
        bottom: selectionRects[i].bottom,
        top: selectionRects[i].top,
        left: selectionRects[i].left,
        right: selectionRects[i].right,
      });
    } else if (
      Math.abs(
        tempRect[tempRect.length - 1].bottom - selectionRects[i].bottom
      ) < 5
    ) {
      if (tempRect[tempRect.length - 1].left > selectionRects[i].left) {
        tempRect[tempRect.length - 1].left = selectionRects[i].left;
      }
      if (tempRect[tempRect.length - 1].right < selectionRects[i].right) {
        tempRect[tempRect.length - 1].right = selectionRects[i].right;
      }
    } else {
      tempRect.push({
        bottom: selectionRects[i].bottom,
        top: selectionRects[i].top,
        left: selectionRects[i].left,
        right: selectionRects[i].right,
      });
    }
  }
  console.log("getCustHightlightCoords9", tempRect);

  // tempRect.map((r) => {
  //   console.log("tempRect", r);
  //   var tableRectDiv = document.createElement("div");
  //   tableRectDiv.style.position = "absolute";
  //   tableRectDiv.style.border = "1px solid red";
  //   var scrollTop =
  //     document.documentElement.scrollTop || document.body.scrollTop;
  //   var scrollLeft =
  //     document.documentElement.scrollLeft || document.body.scrollLeft;
  //   tableRectDiv.style.margin = tableRectDiv.style.padding = 0;
  //   tableRectDiv.style.top = r.top + "px";
  //   tableRectDiv.style.left = r.left + "px";
  //   tableRectDiv.style.width = r.right - r.left + "px";
  //   tableRectDiv.style.height = r.bottom - r.top + 2 + "px";
  //   document.body.appendChild(tableRectDiv);
  // });

  var selected = tempRect.map(function (r) {
    return viewport
      .convertToPdfPoint(r.left - pageRect.x, r.top - pageRect.y)
      .concat(
        viewport.convertToPdfPoint(r.right - pageRect.x, r.bottom - pageRect.y)
      );
  });
  return { page: pageIndex, coords: selected };
};
